import type { ApplicationConfig } from '@angular/core';
import { importProvidersFrom, inject, provideZonelessChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { provideRouter, RouteReuseStrategy } from '@angular/router';
import { IonicRouteStrategy, isPlatform, provideIonicAngular } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage-angular';
import { StoreModule } from '@ngrx/store';
import { kitAuthInterceptor, provideKitAuth, provideKitOverlay } from '@rdlabo/ionic-angular-kit';
import { provideKitFirebase } from '@rdlabo/ionic-angular-kit/auth-firebase';
import { iosTransitionAnimation } from '@rdlabo/ionic-theme-ios26';

import { AuthService } from '../../../shared/src/auth/auth.service';
import { environment } from '../../../shared/src/environments/environment';
import { provideOdssHttp } from '../../../shared/src/http-config';
import { provideOdssSignalForms } from '../../../shared/src/config/signal-forms';
import { reducers } from '../reducer';
import { customerCompanyInterceptor } from './customer-company.service';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideOdssSignalForms(),
    provideRouter(routes),
    provideKitFirebase({ firebaseConfig: environment.firebase }),
    importProvidersFrom(BrowserModule, StoreModule.forRoot(reducers), IonicStorageModule.forRoot()),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    AuthService,
    provideHttpClient(withXhr(), withInterceptors([kitAuthInterceptor, customerCompanyInterceptor])),
    provideOdssHttp(),
    provideIonicAngular({
      backButtonText: '',
      scrollAssist: true,
      swipeBackEnabled: false,
      useSetInputAPI: true,
      navAnimation: isPlatform('ios') ? iosTransitionAnimation : undefined,
    }),
    provideKitOverlay({ labels: { close: '閉じる', cancel: 'キャンセル' } }),
    provideKitAuth(() => {
      const auth = inject(AuthService);
      return {
        authState: () => auth.isAuth$(),
        redirects: {
          whenAuthorized: '/',
          whenConfirming: '/auth/confirm',
          whenNotConfirming: '/auth/signin',
          whenUnauthorized: 'auth',
        },
      };
    }),
  ],
};
